import React from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const { shape, string, arrayOf } = proptypes;

export const GroupsShared = ({ itemGroups, groupsShared }) => {
  const groupCount = groupsShared.length || 0;
  const projectGroupsShared = itemGroups?.filter((group) => {
    return groupsShared.includes(group.id);
  });

  const itemCount = projectGroupsShared.reduce((acc, group) => {
    return (group.products.length || 0) + acc;
  }, 0);

  const groupNames = projectGroupsShared.map((group) => (
    group.isDefault ? 'Unsorted Materials' : group.groupName
  ));

  return (
    <div>
      <Typography>
        Groups{' '}
        <Typography color="subtle" component="span">
          ({itemCount} items | {groupCount} Groups selected)
        </Typography>
      </Typography>
      {groupNames && groupNames.length && (
        <Typography color="subtle" component="span">
          {groupNames.join(', ')}
        </Typography>
      )}
    </div>
  );
};

GroupsShared.propTypes = {
  groupsShared: arrayOf(string).isRequired,
  itemGroups: arrayOf(
    shape({ id: string, groupName: string, products: arrayOf(shape({ id: string })) })
  ).isRequired
};

GroupsShared.defaultProps = {};
